import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ContentElement, LinkTarget, LinkType } from '@urbannex/storethemes';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { Subject, take, takeUntil } from 'rxjs';
import { NbDialogService } from '@nebular/theme';
import { LookupEntityComponent } from '../lookup-entity/lookup-entity.component';
import { OfbizFormField, OfbizTexboxQBEField, LOOKUPCOMBOFORMS, LookupFieldService } from '@urbannex/ofbiz-forms';
import { SiteConfigListenerService } from '../../../services/site-config-listener.service';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { PageType, Site } from '../../../editor-container/editor-model';

@Component({
  selector: 'ngx-action-popover',
  templateUrl: './action-popover.component.html',
  styleUrl: './action-popover.component.scss'
})
export class ActionPopoverComponent implements OnInit, OnDestroy {
  title: string;
  action: LinkTarget;
  linkType: LinkType;
  text: string;
  productId: string;
  categoryId: string;
  articleContentId: string;

  contentElement: ContentElement;
  selectedAction;
  selectedLinkType;

  // Expose enums to template
  linkTargetEnum = LinkTarget;
  linkTypeEnum = LinkType;

  lookupProductField = this.lookupFieldService.getLookupRawField("productId", "LookupProduct", LOOKUPCOMBOFORMS)
  lookupCategoryField = this.lookupFieldService.getLookupRawField("productCategoryId", "LookupProductCategory", LOOKUPCOMBOFORMS);
  lookupArticleField = this.lookupFieldService.getLookupRawField("contentId", "LookupArticle", LOOKUPCOMBOFORMS);

  blogContentId: string

  formField: OfbizFormField<any>;
  lookupProduct = new OfbizTexboxQBEField({
    key: this.lookupProductField.id,
    label: this.lookupProductField.title,
    value: this.lookupProductField.value,
    name: this.lookupProductField.name,
    order: 1,
    // required: this.lookupProductField?.required,
    // endpoint: this.lookupProductField.endpoint,
    lookupOptions: this.lookupProductField.lookupOptions,
  });
  lookupCategory = new OfbizTexboxQBEField({
    key: this.lookupCategoryField.id,
    label: this.lookupCategoryField.title,
    value: this.lookupCategoryField.value,
    name: this.lookupCategoryField.name,
    order: 1,
    // required: this.lookupCategoryField?.required,
    // endpoint: this.lookupCategoryField.endpoint,
    lookupOptions: this.lookupCategoryField.lookupOptions,
  });

  lookupArticle = new OfbizTexboxQBEField({
    key: this.lookupArticleField.id,
    label: this.lookupArticleField.title,
    value: this.lookupArticleField.value,
    name: this.lookupArticleField.name,
    order: 1,
    // required: this.lookupCategoryField?.required,
    // endpoint: this.lookupCategoryField.endpoint,
    lookupOptions: this.lookupArticleField.lookupOptions,
  });

  private destroy$ = new Subject<void>();

  constructor(
    private cellEditorStoreService: CellEditorStoreService,
    private dialogService: NbDialogService,
    private lookupFieldService: LookupFieldService,
    private previewEditStoreService: PreviewEditStoreService,
    private siteConfigListenerService: SiteConfigListenerService,
    private el: ElementRef,
    private renderer2: Renderer2) {
    this.previewEditStoreService.selectedSite$
      .pipe(takeUntil(this.destroy$))
      .subscribe((site: Site) => {
        // console.log(site);
        if (site != undefined) {
          // Set the blogContentId based on the site's pages
          const pages = site.pages;
          if (pages && pages.length > 0) {
            const blogPage = pages.find(page => page.pageType === 'Blog Root');
            if (blogPage) {
              this.blogContentId = blogPage.pageId;
              console.log({ BlogContentId: this.blogContentId });
              this.populateLookupArticle(this.blogContentId)
            } else {
              console.log('No Blog Root page found in the selected site.');
            }
          }
          console.log(site);
        }
      });
    /* this.siteConfigListenerService.selectedSite.pipe(takeUntil(this.destroy$)).subscribe(site => {
      if (site) {
        const pages = site.pages;
        if (pages && pages.length > 0) {
          const blogPage = pages.find(page => page.pageType === 'Blog Root');
          if (blogPage) {
            this.blogContentId = blogPage.pageId;
            console.log({ BlogContentId: this.blogContentId });
          }
        }
      }
    }); */

  }

  ngOnInit(): void {
    this.cellEditorStoreService.activeSelector$.pipe(take(1)).subscribe((content: ContentElement) => {
      if (content) {
        this.contentElement = content;
        this.linkType = content.linkType;
        this.text = content.text;
        if (content.productId) {
          this.productId = content.productId;
        }
        if (content.categoryId) {
          this.categoryId = content.categoryId;
        }
        if (content.articleContentId) {
          this.articleContentId = content.articleContentId;
        }
      }
    })
  }


  onActionChange(action: string): void {
    this.selectedAction = action;
    console.log('Selected Action:', action);
    if (action === "PRODUCT") {
      this.formField = this.lookupProduct;
      console.log(this.formField)
    } else if (action === "CATEGORY") {
      this.formField = this.lookupCategory;
      console.log(this.formField)
    } else if (action === "ARTICLE") {
      this.populateLookupArticle(this.blogContentId);
      this.formField = this.lookupArticle;
      console.log(this.formField)
    }
    // this.renderer2.getElementById(this.el.nativeElement, 'link-type-select').removeAttribute('disabled');
    this.updateContentElement();
  }

  onLinkTypeChange(linkType: string): void {
    this.selectedLinkType = linkType;
    this.updateContentElement();
  }

  onTextChange(text: string): void {
    this.text = text;
    this.updateContentElement();
  }

  openProductLookupDialog(): void {
    this.dialogService.open(LookupEntityComponent, { context: { entityType: 'product' } })
      .onClose.subscribe((selectedProductId: string) => {
        if (selectedProductId) {
          this.productId = selectedProductId;
          this.updateContentElement();
        }
      });
  }

  openCategoryLookupDialog(): void {
    this.dialogService.open(LookupEntityComponent, { context: { entityType: 'category' } })
      .onClose.subscribe((selectedCategoryId: string) => {
        if (selectedCategoryId) {
          this.categoryId = selectedCategoryId;
          this.updateContentElement();
        }
      });
  }
  openArticleLookupDialog(): void {
    this.dialogService.open(LookupEntityComponent, { context: { entityType: 'article' } })
      .onClose.subscribe((selectedArticleId: string) => {
        if (selectedArticleId) {
          this.articleContentId = selectedArticleId;
          this.updateContentElement();
        }
      });
  }

  updateContentElement(): void {
    const updatedContent: ContentElement = {
      ...this.contentElement,
      action: this.selectedAction as LinkTarget,
      linkType: this.selectedLinkType as LinkType,
      text: this.text,
      productId: this.productId,
      categoryId: this.categoryId,
      articleContentId: this.articleContentId
    };

    this.cellEditorStoreService.updateActiveSelectorAndSelectedCell(updatedContent);
  }

  onSave(): void {
    this.updateContentElement();
    // Close popover or perform additional save logic
  }

  onCancel(): void {
    // Close popover without saving
  }
  /**
   *
   * @param e Event emitted when text QBE field is change
   * Consists of the field value and a description
   */
  setTextQBEField(e) {
    console.log({ SetTextQBEField: e });
    switch (this.selectedAction) {
      case "PRODUCT":
        this.productId = e.value;
        this.text = e.description;
        this.updateContentElement();
        break;
      case "CATEGORY":
        this.categoryId = e.value;
        this.text = e.description;
        this.updateContentElement();
        break;
      case "ARTICLE":
        this.articleContentId = e.value;
        this.text = e.description;
        this.updateContentElement();
        break;
      default:
        break;
    }
    console.log("Text QBE field setting not implemented yet", e);
  }

  populateLookupArticle(contentId: string) {
    console.log({ PopulateLookupArticle: contentId });
    const lookupArticleConditionFields: any[] = this.lookupArticle.lookupOptions.conditionFields;
    if (lookupArticleConditionFields && lookupArticleConditionFields.length > 0) {
      lookupArticleConditionFields.forEach(field => {
        Object.entries(field).forEach(([key, value]) => {
          if (key === 'contentIdStart') {
            field[key] = contentId;
          }
        })
      })
    }
    // this.lookupArticle.lookupOptions.conditionFields = []
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
